// src/mockData.ts

import { CardProps } from './Card';

export const cardMockData: CardProps[] = [
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '1번',
    location: '서울',
    date: '오늘',
    people: 10,
    dueDate: 10,
  },
  {
    image: '/assets/social.svg',
    category: 'ongoing',
    title: '2번',
    location: '인천',
    date: '내일',
    people: 3030,
    dueDate: 50000,
  },
  {
    image: '/assets/category.svg',
    category: 'end',
    title: '3번',
    location: '부산',
    date: '모레',
    people: 25,
    dueDate: 0,
  },
  {
    image: '/assets/social.svg',
    category: 'end',
    title: '4번',
    location: '대전',
    date: '2025-02-01',
    people: 150,
    dueDate: 0,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '5번',
    location: '광주',
    date: '2025-01-18',
    people: 500,
    dueDate: 0,
  },
  {
    image: '/assets/social.svg',
    category: 'end',
    title: '6번',
    location: '울산',
    date: '2025-01-22',
    people: 220,
    dueDate: 0,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '7번',
    location: '대구',
    date: '2025-01-19',
    people: 300,
    dueDate: 0,
  },
  {
    image: '/assets/social.svg',
    category: 'end',
    title: '8번',
    location: '제주',
    date: '2025-02-05',
    people: 50,
    dueDate: 0,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '9번',
    location: '서울',
    date: '2025-02-12',
    people: 12,
    dueDate: 0,
  },
  {
    image: '/assets/social.svg',
    category: 'end',
    title: '10번',
    location: '인천',
    date: '2025-02-20',
    people: 1000,
    dueDate: 0,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '11번',
    location: '서울',
    date: '2025-02-21',
    people: 120,
    dueDate: 5,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '12번',
    location: '서울',
    date: '오늘',
    people: 10,
    dueDate: 10,
  },
  {
    image: '/assets/social.svg',
    category: 'ongoing',
    title: '13번',
    location: '인천',
    date: '내일',
    people: 3030,
    dueDate: 50000,
  },
  {
    image: '/assets/category.svg',
    category: 'end',
    title: '14번',
    location: '부산',
    date: '모레',
    people: 25,
    dueDate: 0,
  },
  {
    image: '/assets/social.svg',
    category: 'end',
    title: '15번',
    location: '대전',
    date: '2025-02-01',
    people: 150,
    dueDate: 0,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '16번',
    location: '광주',
    date: '2025-01-18',
    people: 500,
    dueDate: 0,
  },
  {
    image: '/assets/social.svg',
    category: 'end',
    title: '17번',
    location: '울산',
    date: '2025-01-22',
    people: 220,
    dueDate: 0,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '18번',
    location: '대구',
    date: '2025-01-19',
    people: 300,
    dueDate: 0,
  },
  {
    image: '/assets/social.svg',
    category: 'end',
    title: '19번',
    location: '제주',
    date: '2025-02-05',
    people: 50,
    dueDate: 0,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '9번',
    location: '서울',
    date: '2025-02-12',
    people: 12,
    dueDate: 0,
  },
  {
    image: '/assets/social.svg',
    category: 'end',
    title: '10번',
    location: '인천',
    date: '2025-02-20',
    people: 1000,
    dueDate: 0,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '11번',
    location: '서울',
    date: '2025-02-21',
    people: 120,
    dueDate: 5,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '1번',
    location: '서울',
    date: '오늘',
    people: 10,
    dueDate: 10,
  },
  {
    image: '/assets/social.svg',
    category: 'ongoing',
    title: '2번',
    location: '인천',
    date: '내일',
    people: 3030,
    dueDate: 50000,
  },
  {
    image: '/assets/category.svg',
    category: 'end',
    title: '3번',
    location: '부산',
    date: '모레',
    people: 25,
    dueDate: 0,
  },
  {
    image: '/assets/social.svg',
    category: 'end',
    title: '4번',
    location: '대전',
    date: '2025-02-01',
    people: 150,
    dueDate: 0,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '5번',
    location: '광주',
    date: '2025-01-18',
    people: 500,
    dueDate: 0,
  },
  {
    image: '/assets/social.svg',
    category: 'end',
    title: '6번',
    location: '울산',
    date: '2025-01-22',
    people: 220,
    dueDate: 0,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '7번',
    location: '대구',
    date: '2025-01-19',
    people: 300,
    dueDate: 0,
  },
  {
    image: '/assets/social.svg',
    category: 'end',
    title: '8번',
    location: '제주',
    date: '2025-02-05',
    people: 50,
    dueDate: 0,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '9번',
    location: '서울',
    date: '2025-02-12',
    people: 12,
    dueDate: 0,
  },
  {
    image: '/assets/social.svg',
    category: 'end',
    title: '10번',
    location: '인천',
    date: '2025-02-20',
    people: 1000,
    dueDate: 0,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '11번',
    location: '서울',
    date: '2025-02-21',
    people: 120,
    dueDate: 5,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '1번',
    location: '서울',
    date: '오늘',
    people: 10,
    dueDate: 10,
  },
  {
    image: '/assets/social.svg',
    category: 'ongoing',
    title: '2번',
    location: '인천',
    date: '내일',
    people: 3030,
    dueDate: 50000,
  },
  {
    image: '/assets/category.svg',
    category: 'end',
    title: '3번',
    location: '부산',
    date: '모레',
    people: 25,
    dueDate: 0,
  },
  {
    image: '/assets/social.svg',
    category: 'end',
    title: '4번',
    location: '대전',
    date: '2025-02-01',
    people: 150,
    dueDate: 0,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '5번',
    location: '광주',
    date: '2025-01-18',
    people: 500,
    dueDate: 0,
  },
  {
    image: '/assets/social.svg',
    category: 'end',
    title: '6번',
    location: '울산',
    date: '2025-01-22',
    people: 220,
    dueDate: 0,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '7번',
    location: '대구',
    date: '2025-01-19',
    people: 300,
    dueDate: 0,
  },
  {
    image: '/assets/social.svg',
    category: 'end',
    title: '8번',
    location: '제주',
    date: '2025-02-05',
    people: 50,
    dueDate: 0,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '9번',
    location: '서울',
    date: '2025-02-12',
    people: 12,
    dueDate: 0,
  },
  {
    image: '/assets/social.svg',
    category: 'end',
    title: '10번',
    location: '인천',
    date: '2025-02-20',
    people: 1000,
    dueDate: 0,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '11번',
    location: '서울',
    date: '2025-02-21',
    people: 120,
    dueDate: 5,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '1번',
    location: '서울',
    date: '오늘',
    people: 10,
    dueDate: 10,
  },
  {
    image: '/assets/social.svg',
    category: 'ongoing',
    title: '2번',
    location: '인천',
    date: '내일',
    people: 3030,
    dueDate: 50000,
  },
  {
    image: '/assets/category.svg',
    category: 'end',
    title: '3번',
    location: '부산',
    date: '모레',
    people: 25,
    dueDate: 0,
  },
  {
    image: '/assets/social.svg',
    category: 'end',
    title: '4번',
    location: '대전',
    date: '2025-02-01',
    people: 150,
    dueDate: 0,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '5번',
    location: '광주',
    date: '2025-01-18',
    people: 500,
    dueDate: 0,
  },
  {
    image: '/assets/social.svg',
    category: 'end',
    title: '6번',
    location: '울산',
    date: '2025-01-22',
    people: 220,
    dueDate: 0,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '7번',
    location: '대구',
    date: '2025-01-19',
    people: 300,
    dueDate: 0,
  },
  {
    image: '/assets/social.svg',
    category: 'end',
    title: '8번',
    location: '제주',
    date: '2025-02-05',
    people: 50,
    dueDate: 0,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '9번',
    location: '서울',
    date: '2025-02-12',
    people: 12,
    dueDate: 0,
  },
  {
    image: '/assets/social.svg',
    category: 'end',
    title: '10번',
    location: '인천',
    date: '2025-02-20',
    people: 1000,
    dueDate: 0,
  },
  {
    image: '/assets/category.svg',
    category: 'ongoing',
    title: '11번',
    location: '서울',
    date: '2025-02-21',
    people: 120,
    dueDate: 5,
  },
  // 더 많은 mock 데이터가 여기에 추가됩니다 (최대 50개).
  // 예시로 추가된 50개 데이터를 여기에 복사하세요.
];

export const manageMockDataList = [
  {
    title: '[스터디명 A]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 A',
  },
  {
    title: '[스터디명 B]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 B',
  },
  {
    title: '[스터디명 C]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 C',
  },
  {
    title: '[스터디명 D]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 D',
  },
  {
    title: '[스터디명 E]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 E',
  },
  {
    title: '[스터디명 F]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 F',
  },
  {
    title: '[스터디명 G]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 G',
  },
  {
    title: '[스터디명 H]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 H',
  },
  {
    title: '[스터디명 I]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 I',
  },
  {
    title: '[스터디명 J]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 J',
  },
  {
    title: '[스터디명 A]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 A',
  },
  {
    title: '[스터디명 B]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 B',
  },
  {
    title: '[스터디명 C]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 C',
  },
  {
    title: '[스터디명 D]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 D',
  },
  {
    title: '[스터디명 E]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 E',
  },
  {
    title: '[스터디명 F]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 F',
  },
  {
    title: '[스터디명 G]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 G',
  },
  {
    title: '[스터디명 H]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 H',
  },
  {
    title: '[스터디명 I]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 I',
  },
  {
    title: '[스터디명 J]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 J',
  },
  {
    title: '[스터디명 A]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 A',
  },
  {
    title: '[스터디명 B]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 B',
  },
  {
    title: '[스터디명 C]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 C',
  },
  {
    title: '[스터디명 D]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 D',
  },
  {
    title: '[스터디명 E]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 E',
  },
  {
    title: '[스터디명 F]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 F',
  },
  {
    title: '[스터디명 G]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 G',
  },
  {
    title: '[스터디명 H]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 H',
  },
  {
    title: '[스터디명 I]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 I',
  },
  {
    title: '[스터디명 J]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 J',
  },
  {
    title: '[스터디명 A]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 A',
  },
  {
    title: '[스터디명 B]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 B',
  },
  {
    title: '[스터디명 C]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 C',
  },
  {
    title: '[스터디명 D]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 D',
  },
  {
    title: '[스터디명 E]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 E',
  },
  {
    title: '[스터디명 F]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 F',
  },
  {
    title: '[스터디명 G]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 G',
  },
  {
    title: '[스터디명 H]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 H',
  },
  {
    title: '[스터디명 I]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 I',
  },
  {
    title: '[스터디명 J]',
    profileImage: 'assets/Ellipse 20.svg',
    name: '어쩌구 J',
  },
];

export const acceptanceMockDataList = [
  {
    image: 'assets/acceptance-image1.jpg',
    title: '스터디 신청 A',
    location: '서울, 강남',
    date: '2025-01-20',
    userIsAccepted: true,
  },
  {
    image: 'assets/acceptance-image2.jpg',
    title: '스터디 신청 B',
    location: '서울, 홍대',
    date: '2025-01-22',
    userIsAccepted: false,
  },
  {
    image: 'assets/acceptance-image3.jpg',
    title: '스터디 신청 C',
    location: '서울, 이태원',
    date: '2025-01-23',
    userIsAccepted: true,
  },
  {
    image: 'assets/acceptance-image4.jpg',
    title: '스터디 신청 D',
    location: '부산, 해운대',
    date: '2025-01-25',
    userIsAccepted: false,
  },
  {
    image: 'assets/acceptance-image5.jpg',
    title: '스터디 신청 E',
    location: '대구, 동성로',
    date: '2025-02-01',
    userIsAccepted: true,
  },
  {
    image: 'assets/acceptance-image6.jpg',
    title: '스터디 신청 F',
    location: '서울, 명동',
    date: '2025-02-05',
    userIsAccepted: false,
  },
  {
    image: 'assets/acceptance-image7.jpg',
    title: '스터디 신청 G',
    location: '서울, 강남',
    date: '2025-02-10',
    userIsAccepted: true,
  },
  {
    image: 'assets/acceptance-image8.jpg',
    title: '스터디 신청 H',
    location: '서울, 신촌',
    date: '2025-02-12',
    userIsAccepted: null,
  },
  {
    image: 'assets/acceptance-image9.jpg',
    title: '스터디 신청 I',
    location: '인천, 송도',
    date: '2025-02-15',
    userIsAccepted: true,
  },
  {
    image: 'assets/acceptance-image10.jpg',
    title: '스터디 신청 J',
    location: '서울, 왕십리',
    date: '2025-02-20',
    userIsAccepted: false,
  },
  {
    image: 'assets/acceptance-image1.jpg',
    title: '스터디 신청 A',
    location: '서울, 강남',
    date: '2025-01-20',
    userIsAccepted: true,
  },
  {
    image: 'assets/acceptance-image2.jpg',
    title: '스터디 신청 B',
    location: '서울, 홍대',
    date: '2025-01-22',
    userIsAccepted: false,
  },
  {
    image: 'assets/acceptance-image3.jpg',
    title: '스터디 신청 C',
    location: '서울, 이태원',
    date: '2025-01-23',
    userIsAccepted: true,
  },
  {
    image: 'assets/acceptance-image4.jpg',
    title: '스터디 신청 D',
    location: '부산, 해운대',
    date: '2025-01-25',
    userIsAccepted: false,
  },
  {
    image: 'assets/acceptance-image5.jpg',
    title: '스터디 신청 E',
    location: '대구, 동성로',
    date: '2025-02-01',
    userIsAccepted: true,
  },
  {
    image: 'assets/acceptance-image6.jpg',
    title: '스터디 신청 F',
    location: '서울, 명동',
    date: '2025-02-05',
    userIsAccepted: false,
  },
  {
    image: 'assets/acceptance-image7.jpg',
    title: '스터디 신청 G',
    location: '서울, 강남',
    date: '2025-02-10',
    userIsAccepted: true,
  },
  {
    image: 'assets/acceptance-image8.jpg',
    title: '스터디 신청 H',
    location: '서울, 신촌',
    date: '2025-02-12',
    userIsAccepted: null,
  },
  {
    image: 'assets/acceptance-image9.jpg',
    title: '스터디 신청 I',
    location: '인천, 송도',
    date: '2025-02-15',
    userIsAccepted: true,
  },
  {
    image: 'assets/acceptance-image10.jpg',
    title: '스터디 신청 J',
    location: '서울, 왕십리',
    date: '2025-02-20',
    userIsAccepted: false,
  },
  {
    image: 'assets/acceptance-image1.jpg',
    title: '스터디 신청 A',
    location: '서울, 강남',
    date: '2025-01-20',
    userIsAccepted: true,
  },
  {
    image: 'assets/acceptance-image2.jpg',
    title: '스터디 신청 B',
    location: '서울, 홍대',
    date: '2025-01-22',
    userIsAccepted: false,
  },
  {
    image: 'assets/acceptance-image3.jpg',
    title: '스터디 신청 C',
    location: '서울, 이태원',
    date: '2025-01-23',
    userIsAccepted: true,
  },
  {
    image: 'assets/acceptance-image4.jpg',
    title: '스터디 신청 D',
    location: '부산, 해운대',
    date: '2025-01-25',
    userIsAccepted: false,
  },
  {
    image: 'assets/acceptance-image5.jpg',
    title: '스터디 신청 E',
    location: '대구, 동성로',
    date: '2025-02-01',
    userIsAccepted: true,
  },
  {
    image: 'assets/acceptance-image6.jpg',
    title: '스터디 신청 F',
    location: '서울, 명동',
    date: '2025-02-05',
    userIsAccepted: false,
  },
  {
    image: 'assets/acceptance-image7.jpg',
    title: '스터디 신청 G',
    location: '서울, 강남',
    date: '2025-02-10',
    userIsAccepted: true,
  },
  {
    image: 'assets/acceptance-image8.jpg',
    title: '스터디 신청 H',
    location: '서울, 신촌',
    date: '2025-02-12',
    userIsAccepted: null,
  },
  {
    image: 'assets/acceptance-image9.jpg',
    title: '스터디 신청 I',
    location: '인천, 송도',
    date: '2025-02-15',
    userIsAccepted: true,
  },
  {
    image: 'assets/acceptance-image10.jpg',
    title: '스터디 신청 J',
    location: '서울, 왕십리',
    date: '2025-02-20',
    userIsAccepted: false,
  },
  {
    image: 'assets/acceptance-image1.jpg',
    title: '스터디 신청 A',
    location: '서울, 강남',
    date: '2025-01-20',
    userIsAccepted: true,
  },
  {
    image: 'assets/acceptance-image2.jpg',
    title: '스터디 신청 B',
    location: '서울, 홍대',
    date: '2025-01-22',
    userIsAccepted: false,
  },
  {
    image: 'assets/acceptance-image3.jpg',
    title: '스터디 신청 C',
    location: '서울, 이태원',
    date: '2025-01-23',
    userIsAccepted: true,
  },
  {
    image: 'assets/acceptance-image4.jpg',
    title: '스터디 신청 D',
    location: '부산, 해운대',
    date: '2025-01-25',
    userIsAccepted: false,
  },
  {
    image: 'assets/acceptance-image5.jpg',
    title: '스터디 신청 E',
    location: '대구, 동성로',
    date: '2025-02-01',
    userIsAccepted: true,
  },
  {
    image: 'assets/acceptance-image6.jpg',
    title: '스터디 신청 F',
    location: '서울, 명동',
    date: '2025-02-05',
    userIsAccepted: false,
  },
  {
    image: 'assets/acceptance-image7.jpg',
    title: '스터디 신청 G',
    location: '서울, 강남',
    date: '2025-02-10',
    userIsAccepted: true,
  },
  {
    image: 'assets/acceptance-image8.jpg',
    title: '스터디 신청 H',
    location: '서울, 신촌',
    date: '2025-02-12',
    userIsAccepted: null,
  },
  {
    image: 'assets/acceptance-image9.jpg',
    title: '스터디 신청 I',
    location: '인천, 송도',
    date: '2025-02-15',
    userIsAccepted: true,
  },
  {
    image: 'assets/acceptance-image10.jpg',
    title: '스터디 신청 J',
    location: '서울, 왕십리',
    date: '2025-02-20',
    userIsAccepted: false,
  },
];
